import {
  MASKING_TEMPLATES,
  TRANSFORMATION_TEMPLATES,
} from "@/constants/studioTemplates";

// The transform editor's script templates. The editor's zero state and
// context menu show three hero entries; the AI Helper's script.template
// action reaches the whole catalog by kebab-case id (maskEmail →
// mask-email), with the hero names kept as aliases.

export type ScriptTemplateGroup = "masking" | "transformation";

export interface ScriptTemplate {
  id: string;
  label: string;
  group: ScriptTemplateGroup;
  script: string;
}

const kebab = (key: string) =>
  key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

function fromCatalog(
  group: ScriptTemplateGroup,
  catalog: Record<string, { label: string; script: string }>,
): ScriptTemplate[] {
  return Object.entries(catalog).map(([key, t]) => ({
    id: kebab(key),
    label: t.label,
    group,
    script: t.script,
  }));
}

export const SCRIPT_TEMPLATES: ScriptTemplate[] = [
  ...fromCatalog("masking", MASKING_TEMPLATES),
  ...fromCatalog("transformation", TRANSFORMATION_TEMPLATES),
];

// The editor's own names for its three links.
const ALIASES: Record<string, string> = {
  masking: "mask-email",
  passthrough: "passthrough",
  "field-mapping": "field-mapping",
};

export function scriptTemplate(id: string): ScriptTemplate | undefined {
  const key = ALIASES[id] ?? id;
  return SCRIPT_TEMPLATES.find((t) => t.id === key);
}

// The zero-state links and context-menu entries of the transform editor
// (/studio's buildScriptEmptyStateActions): three, by design.
export const HERO_TEMPLATES: Array<{
  id: string;
  label: string;
  script: string;
}> = [
  { id: "masking", label: "Masking template" },
  { id: "passthrough", label: "Passthrough template" },
  { id: "field-mapping", label: "Field mapping template" },
]
  .map((hero) => {
    const t = scriptTemplate(hero.id);
    return t ? { ...hero, script: t.script } : null;
  })
  .filter(
    (t): t is { id: string; label: string; script: string } => t !== null,
  );
